import React, { useEffect, useState, useMemo, useRef } from "react";
import { connect } from "react-redux";
import {
    getPrivateProjectById,
    getPostulationProjectStatus,
    validateAccessRequest,
    openNDAModal,
    getPostulations,
    setPostulationProjectId,
    setProjectToEdit,
    setPostulationProject,
    getProjectQuestions,
    getSubProjectBudgets,
} from "../../../../store/actions";
import { useNewProjectCreation } from "../../../../hooks/newProject/useNewProjectCreation.ts";
import BotoneraModern from "../../../Botonera/BotoneraModern.tsx";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./ProyectoId.module.scss";
import { ReactComponent as FacebookIcon } from "../../../../assets/svg/Facebook.svg";
import { ReactComponent as InstagramIcon } from "../../../../assets/svg/Instagram.svg";
import { ReactComponent as LinkedinIcon } from "../../../../assets/svg/LinkedIN.svg";
import { ReactComponent as TwitterIcon } from "../../../../assets/svg/twitterSvg.svg";
import { ReactComponent as WhatsAppIcon } from "../../../../assets/svg/whatsAppIcon.svg";
import ProjectQuestions from "./ProjectQuestions";
import ProjectAnswer from "./ProjectAnswer";
import CustomCarousel from "../../../UI/CustomCarousel/CustomCarousel";
import ImageWithBlurBackground from "../../../UI/ImageWithBlurBackground/ImageWithBlurBackground";
import "./NukaCarousel.css";
import { motion } from "framer-motion";
import ProyectoSkeletonLoader from "./ProjectSkeleton";
import NewNavImproved from "../../../Nav/NewNavImproved.tsx";
import styled from "styled-components";
import SubProjectInformation from "./SubProjectInformationV2.tsx";
import Breadcrumbs from "../../../UI/Breadcrumbs/Breadcrumbs.tsx";
import UploadBudgetDisclaimer from "./UploadBudgetDisclaimer";
import ProjectManagementModal from "./ProjectManagementModal.tsx";
import {
    MapPin,
    CalendarDays,
    FileText,
    Bookmark,
    HardHat,
    UserCheck,
    UserRoundX,
    Send,
    MessageSquare,
    Briefcase,
    Clock,
    ChevronRight,
    Upload
} from "lucide-react";
import { fireAnalytics } from "../../../../utils/firebase";
import { usePostulationsFilter } from "../../../../hooks/usePostulationsFilter.ts";

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding-right: 5%;
  padding-left: 5%;
  max-width: 150rem;
        margin: auto;

  @media (max-width: 1200px) {
    padding-right: 5%;
    padding-left: 5%;
    }

    @media (max-width: 900px) {
        padding-right: 0;
        padding-left: 0;
}

    @media (max-width: 600px) {
        padding-right: 0;   
        padding-left: 0;
    }

`;


const ProyectoId = ({
    setProjectLoading,
    getPrivateProjectById,
    getPostulationProjectStatus,
    getProjectQuestions,
    postulacionesDelUsuario,
    postulacionesDeProyecto,
    projectQuestions,
    getSubProjectBudgets,
    proyecto,
    openNDAModal,
    validateAccessRequest,
    getPostulations,
    setProjectToEdit,
    setPostulationProject,
    setPostulationProjectId,
    budgets,
    userData,
    ...props }) => {
    const [showSubProjectDocus, setShowSubProjectDocus] = useState(null);
    const [ocultarEnMobile, setOcultarEnMobile] = useState(false);
    const [mobileStylesFromParent, setMobileStylesFromParent] = useState(false);
    const [showPostulationModal, setShowPostulationModal] = useState(null);
    const [showQuestionsModal, setShowQuestionsModal] = useState(false);
    const [showAnswerModal, setShowAnswerModal] = useState(false);
    const [questionToAnswer, setQuestionToAnswer] = useState(null);
    const [randomImage, setRandomImage] = useState("");
    const [showManagementModal, setShowManagementModal] = useState(false);
    const documentationRef = useRef(null);
    const { id } = useParams();
    const navigate = useNavigate();
    const { deleteProjectWithFlow } = useNewProjectCreation();

    const isOwnProject = proyecto?.user?.id === userData?.id;
    const projectQuestionsForProject = proyecto?.id ? projectQuestions?.[proyecto.id] || [] : [];
    const filteredPostulations = usePostulationsFilter(postulacionesDeProyecto || []);
    const subprojectIds = useMemo(() => {
        if (!Array.isArray(proyecto?.subproyecto)) {
            return [];
        }
        return proyecto.subproyecto
            .map((subProject) => subProject?.id)
            .filter((id) => id != null);
    }, [proyecto?.subproyecto]);
    const subprojectIdsKey = useMemo(() => subprojectIds.map((id) => id?.toString() ?? "").join("|"), [subprojectIds]);
    const totalBudgetsCount = useMemo(() => {
        if (!Array.isArray(proyecto?.subproyecto) || proyecto.subproyecto.length === 0) return 0;
        return proyecto.subproyecto.reduce((total, subProject) => {
            const budgetKey = subProject?.id;
            if (budgetKey == null) {
                return total;
            }
            const subProjectBudgets = budgets && typeof budgets === "object" ? budgets[budgetKey] || budgets[String(budgetKey)] || [] : [];
            return total + (Array.isArray(subProjectBudgets) ? subProjectBudgets.length : 0);
        }, 0);
    }, [proyecto?.subproyecto, budgets]);
    const managementPendingCount = (filteredPostulations?.counts?.received || 0) + totalBudgetsCount;

    const { facebook = '', instagram = '', linkedin = '', twitter = '', phone = '' } = proyecto?.user || {};

    const noSocialNetworks = !facebook && !instagram && !linkedin && !twitter && !phone;

    useEffect(() => {
        if (!isOwnProject || subprojectIds.length === 0) {
            return;
        }
        subprojectIds.forEach((subId) => {
            getSubProjectBudgets(subId);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOwnProject, subprojectIdsKey, getSubProjectBudgets]);

    useEffect(() => {
        if (proyecto?.proyecto_images && proyecto?.proyecto_images.length === 0) {
            getRandomImage();
        }
        getProjectQuestions(parseInt(id));
    }, [proyecto.id]);

    useEffect(() => {
    const handleResize = () => {
        const windowWidth = window.innerWidth;
        setOcultarEnMobile(windowWidth < 768);
        setMobileStylesFromParent(windowWidth < 768);
    };

        handleResize();

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const formatDate = (date) => {
        const utcDate = new Date(date);
        const year = utcDate.getUTCFullYear();
        const monthNames = [
            'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
            'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
        ];
        const month = monthNames[utcDate.getUTCMonth()];
        const day = utcDate.getUTCDate();
        return `${day} de ${month} ${year}`;
    };

    useEffect(() => {
        getPrivateProjectById(id);
        getPostulationProjectStatus(parseInt(id));
        getPostulations(userData.id);
    }, []);

    const handleAccessRequest = (permisoId, status, solicitudType) => {

        validateAccessRequest(permisoId, status, solicitudType);
        setTimeout(() => {
            getPostulationProjectStatus(parseInt(id));
        }, 3000);
    }


    const openPostulationModal = () => {
        setPostulationProjectId(proyecto?.id);
        openNDAModal(true);
    }
    //Define que boton mostrar
    const isPostulationSent = postulacionesDelUsuario.find(postulacion => postulacion.proyecto?.id === proyecto?.id && postulacion.status === "SEND");
    const isPostulationAllowed = postulacionesDelUsuario.find(postulacion => postulacion.proyecto?.id === proyecto?.id && postulacion.status === "ALLOWED");
    const isPostulationDenied = postulacionesDelUsuario.find(postulacion => postulacion.proyecto?.id === proyecto?.id && postulacion.status === "NEGATED");
    const isPostulationAvailable = !isOwnProject && !isPostulationSent && !isPostulationAllowed && !isPostulationDenied;


    let userPostulationStatus;
    if (isPostulationSent) {
        userPostulationStatus = isPostulationSent.status;
    } else if (isPostulationAllowed) {
        userPostulationStatus = isPostulationAllowed.status;
    } else if (isPostulationDenied) {
        userPostulationStatus = isPostulationDenied.status;
    }

    const handlePostulationButton = () => {
        fireAnalytics("documentation_access_request", {
            category: "project_interaction",
            project_id: proyecto?.id,
            edify_user_id: userData?.id,
            action: "request_documentation_access",
            postulation_status: userPostulationStatus || "none",
            has_documentation: proyecto?.subproyecto?.some(sub =>
                sub.budget_payroll || sub.planos || sub.metric_computation || sub.technical_specifications || sub.link
            ),
            subprojects_count: proyecto?.subproyecto?.length || 0
        });

        if (isPostulationSent) {
            setShowPostulationModal("sent");
        } else if (isPostulationAvailable) {
            openPostulationModal();
        } else if (isPostulationDenied) {
            setShowPostulationModal("denied");
        } else if (isPostulationAllowed) {
            setShowPostulationModal("allowed");
        } else {
            setShowPostulationModal(null);
        }
    }

    const handleAnswerQuestion = (question) => {
        setQuestionToAnswer(question);
        setShowAnswerModal(true);
    }

    const handleEditProject = () => {
        setPostulationProject(proyecto);
        setProjectToEdit(parseInt(proyecto.id));
        navigate(`/obrasprivadas/edit/${proyecto.id}`);
    }

    const handleDeleteProject = () => {
        deleteProjectWithFlow(parseInt(proyecto.id));
    }

    const handleUserRedirect = () => {
        const userId = proyecto?.user?.id;
        navigate(`/perfil/${userId}`);
    }

    const constructionImages = [
        "https://images.pexels.com/photos/534220/pexels-photo-534220.jpeg?auto=compress&cs=tinysrgb&w=600",
        "https://images.pexels.com/photos/209266/pexels-photo-209266.jpeg?auto=compress&cs=tinysrgb&w=600",
        "https://images.pexels.com/photos/1451416/pexels-photo-1451416.jpeg?auto=compress&cs=tinysrgb&w=600",
        "https://images.pexels.com/photos/534228/pexels-photo-534228.jpeg?auto=compress&cs=tinysrgb&w=600"
    ];

    const getRandomImage = () => {
        const randomIndex = Math.floor(Math.random() * constructionImages.length);
        return setRandomImage(constructionImages[randomIndex]);
    }

    let textToShow = isPostulationAllowed ? "Aceptado" : isPostulationDenied ? "Solicitud rechazada" : isPostulationSent ? "Esperando respuesta" : "Enviar postulación";
    let iconToShow = isPostulationAllowed ? <UserCheck size={20} /> : isPostulationDenied ? <UserRoundX size={20} /> : isPostulationSent ? <Clock size={20} /> : <Send size={20} />;

    const handleShowSubProjectsDocs = (index) => {
        setShowSubProjectDocus((prev) => (prev === index ? null : index));
    }

    const handleFocusDocumentation = () => {
        if (Array.isArray(proyecto?.subproyecto) && proyecto.subproyecto.length > 0) {
            setShowSubProjectDocus(0);
        }
        if (documentationRef.current) {
            documentationRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }

    const calculateDaysLeft = (endDate) => {
        if (!endDate) return "No definido";
        const today = new Date();
        const end = new Date(endDate);
        const diff = end - today;
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        return days;
    }

    const questionCount = projectQuestionsForProject.length;
    const formattedStartDate = proyecto?.startDate ? formatDate(proyecto.startDate) : null;
    const formattedEndDate = proyecto?.endDate ? formatDate(proyecto.endDate) : null;

    return (
        <Container>
            {!ocultarEnMobile && <NewNavImproved />}

            <main className={styles.mainContainer}>
                {setProjectLoading ? <ProyectoSkeletonLoader /> :
                    (
                        <>
                            <div className={styles.breadcrumbContainer}>
                                <Breadcrumbs />
                            </div>
                            <section className={styles.projectHero}>
                                <div className={styles.projectHero_content}>
                                    <div className={styles.projectHero_header}>
                                        <span className={styles.projectHero_label}>Proyecto privado</span>
                                        <h1 className={styles.projectHero_title}>{proyecto?.name || "Proyecto sin nombre"}</h1>
                                    </div>
                                </div>
                                <div className={styles.projectHero_actions}>
                                    {isOwnProject ? (
                                        <button
                                            type="button"
                                            className={styles.projectHero_manageButton}
                                            onClick={() => setShowManagementModal(true)}
                                        >
                                            Gestionar proyecto
                                            {managementPendingCount > 0 && (
                                                <span className={styles.projectHero_manageBadge}>
                                                    {managementPendingCount > 99 ? "99+" : managementPendingCount}
                                                </span>
                                            )}
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            className={`${styles.projectHero_cta} ${isPostulationSent && styles.sent} ${isPostulationAllowed && styles.allowed} ${isPostulationDenied && styles.denied}`}
                                            onClick={handlePostulationButton}
                                        >
                                            {iconToShow}
                                            <span>{textToShow}</span>
                                        </button>
                                    )}
                                </div>
                            </section>
                            <div className={styles.contentLayout}>
                                <div className={styles.primaryColumn}>
                                <section className={styles.cards_datos}>
                                    {proyecto?.proyecto_images && proyecto?.proyecto_images.length > 0 ? (
                                        <CustomCarousel showArrows={true}>
                                            {proyecto?.proyecto_images.map((image, index) => (
                                                <ImageWithBlurBackground
                                                    key={index}
                                                    src={image.image}
                                                    alt={proyecto.name || `Image ${index + 1}`}
                                                    className={styles.carouselImage}
                                                />
                                            ))}
                                        </CustomCarousel>
                                    ) : (
                                        <div className={styles.cards_datos_imageContainer}>
                                            <img
                                                src={randomImage}
                                                alt="Imagen de proyecto"
                                                className={styles.cards_datos_imageContainer_image}
                                            />
                                        </div>
                                    )}
                                    <div className={styles.cards_datos_container}>
                                        <div className={styles.cards_datos_container_header}>
                                            <h3 className={styles.cards_datos_title}>
                                                Detalles del proyecto
                                            </h3>
                                            <div className={styles.cards_datos_container_header_items}>
                                                <div className={styles.cards_datos_container_header_item}>
                                                    <div className={styles.cards_datos_container_header_item_label}>
                                                        <Bookmark size={16} />
                                                        <span className={styles.cards_datos_container_header_item_label}>Nombre</span>
                                                    </div>
                                                    <p className={styles.cards_datos_container_header_item_value}>{proyecto?.name}</p>
                                                </div>
                                                <div className={styles.cards_datos_container_header_item}>
                                                    <div className={styles.cards_datos_container_header_item_label}>
                                                        <HardHat size={16} />
                                                        <span className={styles.cards_datos_container_header_item_label}>Rubro/s a cotizar</span>
                                                    </div>
                                                    <div className={styles.cards_datos_container_header_item_jobContainer}>
                                                        {Array.isArray(proyecto?.subproyecto) &&
                                                            proyecto?.subproyecto.map((subproject, index) => {
                                                                return (
                                                                    <p className={styles.cards_datos_container_header_item_job} key={index}>
                                                                        {subproject.name}
                                                                    </p>
                                                                );

                                                            })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={styles.cards_datos_container_body}>
                                            <span className={styles.cards_datos_container_item}>
                                                <FileText size={16} />
                                                Descripción
                                            </span>
                                            <p className={styles.cards_datos_container_description}>{proyecto?.description}</p>
                                        </div>
                                    </div>
                                    <div className={styles.cards_datos_container_documentation} ref={documentationRef}>
                                        <h3 className={styles.cards_datos_title}>
                                            Información para cotizar
                                        </h3>
                                        <div className={styles.cards_datos_container_documentation_items}>
                                            {Array.isArray(proyecto?.subproyecto) &&
                                                proyecto?.subproyecto.map((subproject, index) => {
                                                    return (
                                                        <div key={index}>
                                                            <div className={styles.cards_datos_container_documentation_item} >
                                                                <div className={styles.cards_datos_container_documentation_item_label}>
                                                                    <div className={styles.cards_datos_container_documentation_item_label_icon}>
                                                                        <Briefcase size={16} />
                                                                    </div>
                                                                    <span className={styles.cards_datos_container_documentation_item_label_text}>{subproject.name}</span>
                                                                </div>
                                                                <div className={styles.cards_datos_container_documentation_item_icon} onClick={() => handleShowSubProjectsDocs(index)}>
                                                                    <ChevronRight size={16} />
                                                                </div>

                                                            </div>
                                                            {showSubProjectDocus === index && (
                                                                <motion.div
                                                                    initial={{ opacity: 0 }}
                                                                    animate={{ opacity: 1 }}
                                                                    exit={{ opacity: 0 }}
                                                                    transition={{ duration: 0.3 }}
                                                                    className={styles.cards_datos_container_documentation_item_docus}>
                                                                    <div className={styles.cards_datos_container_documentation_item_docus_dates}>
                                                                        <div className={styles.cards_datos_container_documentation_item_docus_dates_container}>
                                                                            <div className={styles.cards_datos_container_documentation_item_docus_dateItem}>
                                                                                <span>Inicio</span>
                                                                                <span className={styles.cards_datos_container_documentation_item_docus_date}>{formatDate(subproject.startDate)}</span>
                                                                            </div>
                                                                            <div className={styles.cards_datos_container_documentation_item_docus_divider} />
                                                                            <div className={styles.cards_datos_container_documentation_item_docus_dateItem}>
                                                                                <span>Fin</span>
                                                                                <span className={styles.cards_datos_container_documentation_item_docus_date}>{formatDate(subproject.endDate)}</span>
                                                                            </div>
                                                                            <div className={styles.cards_datos_container_documentation_item_docus_daysLeft} >
                                                                                <Clock size={16} />
                                                                                <span className={styles.cards_datos_container_documentation_item_docus_daysLeft_days}>{calculateDaysLeft(subproject?.endDate)}</span>
                                                                                <span className={styles.cards_datos_container_documentation_item_docus_daysLeft_title}>Días restantes</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {subproject?.description && subproject?.description !== "undefined" && (
                                                                        <div className={styles.cards_datos_container_documentation_item_docus_description}>
                                                                            <span className={styles.cards_datos_container_documentation_item_docus_description_title}>
                                                                                <FileText size={16} />
                                                                                Descripción
                                                                            </span>
                                                                            <p className={styles.cards_datos_container_documentation_item_docus_description_text}>
                                                                                {subproject.description}
                                                                            </p>
                                                                        </div>
                                                                    )}
                                                                    <div className={styles.cards_datos_container_documentation_item_docus_info}>
                                                                        <h4 className={styles.cards_datos_container_documentation_item_docus_title}>
                                                                            Documentación disponible
                                                                        </h4>
                                                                        <div className={styles.cards_datos_container_documentation_item_docus_files_container}>
                                                                            <SubProjectInformation
                                                                                mainProjectId={proyecto?.id}
                                                                                subproyecto={subproject}
                                                                                postulationStatus={userPostulationStatus}
                                                                                handlePostulationButton={handlePostulationButton}
                                                                                isMyProject={isOwnProject}
                                                                                type={"isProject"} />
                                                                        </div>
                                                                    </div>
                                                                    <UploadBudgetDisclaimer />
                                                                </motion.div >
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    </div>
                                </section>
                                <section className={styles.cards_questions}>
                                    <div className={styles.cards_questions_container}>
                                        <h3 className={styles.cards_questions_title}>
                                            Preguntas
                                            <span className={styles.cards_questions_title_count}>
                                                    {questionCount}
                                            </span>
                                        </h3>
                                        {projectQuestionsForProject.length > 0 ? (
                                            projectQuestionsForProject.map((question, index) => {
                                                const hasAnswer = !!question.answer;
                                                const isOwnAndNoAnswer = isOwnProject && !hasAnswer;

                                                return (
                                                    <div className={styles.cards_questions_container_question} key={index}>
                                                        <p className={styles.cards_questions_container_question_title}>{question.question}</p>
                                                        {isOwnAndNoAnswer ? (

                                                            <div className={styles.cards_questions_container_question_answerButtonContainer}>
                                                                <p className={styles.cards_questions_container_question_noAnswer}>
                                                                    <Clock size={16} style={{ minHeight: "1.6rem", minWidth: "1.6rem" }} />
                                                                    Sin responder
                                                                </p>
                                                                <button
                                                                    className={styles.cards_questions_container_question_answerButton}
                                                                    onClick={() => handleAnswerQuestion(question)}
                                                                >
                                                                    Responder
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            hasAnswer ? (
                                                                <p className={styles.cards_questions_container_question_answer}>
                                                                    {question.answer}
                                                                </p>
                                                            ) : (
                                                                <p className={styles.cards_questions_container_question_answerEmpty}>
                                                                    <Clock size={16} style={{ minHeight: "1.6rem", minWidth: "1.6rem" }} />
                                                                    El creador del proyecto aún no ha respondido
                                                                </p>
                                                            )
                                                        )}
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            <div className={styles.cards_questions_empty}>
                                                <div className={styles.cards_questions_empty_icon}>
                                                    <MessageSquare size={30} />
                                                </div>
                                                <p className={styles.cards_questions_empty_text}>Nadie hizo preguntas aún</p>
                                                {!isOwnProject && (
                                                    <div className={styles.cards_questions_buttonContainer}>
                                                        <button className={styles.cards_questions_button} onClick={() => setShowQuestionsModal(true)}>
                                                            ¡Hacé la primera!
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        {projectQuestionsForProject.length > 0 && !isOwnProject && (
                                            <div className={styles.cards_questions_container_question_input} onClick={() => setShowQuestionsModal(true)}>
                                                <p className={styles.cards_questions_container_question_input_placeholder}>
                                                    Hacer una pregunta
                                                </p>
                                                <Send size={16} style={{ minHeight: "1.6rem", minWidth: "1.6rem", color: "rgb(37 99 235)" }} />
                                            </div>
                                        )}
                                    </div>
                                </section>
                                </div>
                                <aside className={styles.secondaryColumn}>
                                    <div className={styles.cards_user}>
                                        <div className={styles.cards_user_container} onClick={() => handleUserRedirect()}>
                                            <div className={styles.cards_user_container_user}>
                                                <img src={proyecto?.user?.image_profile} alt="Imagen de perfil" className={styles.cards_user_container_user_image} />
                                                <div className={styles.cards_user_container_user_data}>
                                                    <p className={styles.cards_user_container_user_name}>{proyecto?.user?.type === "COMPANY"
                                                        ? proyecto?.user?.razon_social
                                                        : `${proyecto?.user?.name || ""} ${proyecto?.user?.last_name || ""}`.trim()}</p>
                                                    <span className={styles.cards_user_container_user_title}>Creador del proyecto</span>
                                                </div>
                                            </div>
                                            {noSocialNetworks ? null : (
                                                <div className={styles.cards_user_container_user_socialNetworksContainer_icons}>
                                                    {facebook && (
                                                        <div className={styles.cards_user_container_user_socialNetworksContainer_item}>
                                                            <a href={facebook} target="_blank" rel="noreferrer" className={styles.cards_user_container_user_socialNetworksContainer_item_label}>
                                                                <FacebookIcon width={20} height={20} />
                                                            </a>
                                                        </div>
                                                    )}
                                                    {instagram && (
                                                        <div className={styles.cards_user_container_user_socialNetworksContainer_item}>
                                                            <a href={instagram} target="_blank" rel="noreferrer" className={styles.cards_user_container_user_socialNetworksContainer_item_label}>
                                                                <InstagramIcon width={20} height={20} />
                                                            </a>
                                                        </div>
                                                    )}
                                                    {linkedin && (
                                                        <div className={styles.cards_user_container_user_socialNetworksContainer_item}>
                                                            <a href={linkedin} target="_blank" rel="noreferrer" className={styles.cards_user_container_user_socialNetworksContainer_item_label}>
                                                                <LinkedinIcon width={20} height={20} />
                                                            </a>
                                                        </div>
                                                    )}
                                                    {twitter && (
                                                        <div className={styles.cards_user_container_user_socialNetworksContainer_item} >
                                                            <a href={twitter} target="_blank" rel="noreferrer" className={styles.cards_user_container_user_socialNetworksContainer_item_label}>
                                                                <TwitterIcon width={20} height={20} />
                                                            </a>
                                                        </div>
                                                    )}
                                                    {phone && (
                                                        <div className={styles.cards_user_container_user_socialNetworksContainer_item}>
                                                            <a href={`https://wa.me/${phone}`} target="_blank" rel="noreferrer" className={styles.cards_user_container_user_socialNetworksContainer_item_label}>
                                                                <WhatsAppIcon width={20} height={20} />
                                                            </a>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <div className={styles.cards_user_location}>
                                            <div className={styles.cards_user_location_label}>
                                                <MapPin size={16} style={{ minWidth: "1.6rem" }} />
                                                Ubicación
                                            </div>
                                            <p className={styles.cards_user_location_value}>{proyecto?.zone || "Sin especificar"}</p>
                                        </div>
                                        <div className={styles.cards_user_location}>
                                            <div className={styles.cards_user_location_label}>
                                                <CalendarDays size={16} style={{ minWidth: "1.6rem" }} />
                                                Fechas del proyecto
                                            </div>
                                            <div className={styles.cards_user_dates}>
                                                <span className={styles.cards_user_dates_dateTitle}>Inicio</span>
                                                <span className={styles.cards_user_dates_date}>{formattedStartDate || "Sin definir"}</span>
                                                <span className={styles.cards_user_dates_dateEnd}>Fin</span>
                                                <span className={styles.cards_user_dates_date}>{formattedEndDate || "Sin definir"}</span>
                                            </div>
                                        </div>

                                        {isOwnProject ? (
                                            <button
                                                type="button"
                                                className={`${styles.cards_user_cta} ${styles.cards_user_manage}`}
                                                onClick={() => setShowManagementModal(true)}
                                            >
                                                Gestionar proyecto
                                                {managementPendingCount > 0 && (
                                                    <span className={styles.cards_user_manageBadge}>
                                                        {managementPendingCount > 99 ? "99+" : managementPendingCount}
                                                    </span>
                                                )}
                                            </button>
                                        ) : (
                                            <>
                                                {isPostulationAllowed && (
                                                    <div className={styles.cards_user_assist}>
                                                        <div className={styles.cards_user_assist_title}>Ya podés enviar tu presupuesto</div>
                                                        <ul className={styles.cards_user_assist_steps}>
                                                            <li>
                                                                <FileText size={16} />
                                                                <span>Descargá la documentación del proyecto</span>
                                                            </li>
                                                            <li>
                                                                <Upload size={16} />
                                                                <span>Prepará tu propuesta con los detalles necesarios</span>
                                                            </li>
                                                            <li>
                                                                <Send size={16} />
                                                                <span>Subí la cotización desde la sección Presupuestos</span>
                                                            </li>
                                                        </ul>
                                                        <button
                                                            type="button"
                                                            className={styles.cards_user_assist_cta}
                                                            onClick={handleFocusDocumentation}
                                                        >
                                                            <Upload size={16} />
                                                            <span>Ir a la documentación</span>
                                                        </button>
                                                    </div>
                                                )}
                                                <button
                                                    type="button"
                                                    className={`${styles.cards_user_cta} ${isPostulationSent && styles.sent} ${isPostulationAllowed && styles.allowed} ${isPostulationDenied && styles.denied}`}
                                                    onClick={handlePostulationButton}
                                                >
                                                    {iconToShow}
                                                    <span>{textToShow}</span>
                                                </button>

                                            </>
                                        )}

                                    </div>

                                </aside>
                            </div>
                        </>
                    )
                }
                {
                    showPostulationModal && (
                        <div className={styles.postulationModal}>
                            <section className={styles.postulationModal_body}>
                                <header className={styles.postulationModal_header}>
                                    <button className={styles.postulationModal_header_close} onClick={() => setShowPostulationModal(false)}>X</button>
                                </header>
                                <h2 className={styles.postulationModal_body_title}>
                                    {showPostulationModal === "sent" && "Solicitud enviada"}
                                    {showPostulationModal === "denied" && "Solicitud rechazada"}
                                    {showPostulationModal === "allowed" && "Solicitud aceptada"}
                                </h2>
                                <div className={styles.postulationModal_body_imageContainer}>
                                    {showPostulationModal === "sent" && <img src={"https://cdn-icons-png.flaticon.com/128/4539/4539472.png"} alt="Sent" className={styles.postulationModal_body_image} />}
                                    {showPostulationModal === "denied" && <img src={"https://cdn-icons-png.flaticon.com/128/1828/1828843.png"} alt="Denied" className={styles.postulationModal_body_image} />}
                                    {showPostulationModal === "allowed" && <img src={"https://cdn-icons-png.flaticon.com/128/8215/8215539.png"} alt="Accepted" className={styles.postulationModal_body_image} />}
                                </div>
                                <p className={styles.postulationModal_body_txt}>
                                    {showPostulationModal === "sent" && "El creador del proyecto aún no te habilitó para cotizar"}
                                    {showPostulationModal === "denied" && "El creador del proyecto ha rechazado tu solicitud de participación en el proyecto"}
                                    {showPostulationModal === "allowed" && "Ya puedes descargar toda la documentación en la sección 'Información para cotizar'"} </p>
                            </section>
                        </div>
                    )
                }
                {
                    showManagementModal && (
                        <ProjectManagementModal
                            proyecto={proyecto}
                            postulacionesDeProyecto={postulacionesDeProyecto}
                            budgets={budgets}
                            onClose={() => setShowManagementModal(false)}
                            handleAccessRequest={handleAccessRequest}
                            handleEditProject={handleEditProject}
                            handleDeleteProject={handleDeleteProject}

                        />
                    )
                }
            </main >
            {showAnswerModal &&
                <ProjectAnswer closeModal={() => setShowAnswerModal(false)} question={questionToAnswer} projectId={proyecto.id} />
            }
            {
                showQuestionsModal &&
                <ProjectQuestions projectId={proyecto.id} closeModal={() => setShowQuestionsModal(false)} />
            }
            {
                ocultarEnMobile ? <BotoneraModern mobileStylesFromParent={mobileStylesFromParent} /> :
                    null
            }
        </Container >
    );
}

const mapStateToProps = (state) => {
    return {
        userData: state.general.userData,
        proyecto: state.profile.proyectoPrivadoPorId,
        postulacionesDeProyecto: state.profile.postulationsInProject,
        postulacionesDelUsuario: state.profile.postulations,
        projectQuestions: state.profile.projectQuestions,
        setProjectLoading: state.profile.setProjectLoading,
        budgets: state.profile.subProjectBudgets,
    };
}

export default connect(mapStateToProps, {
    getPrivateProjectById,
    getPostulationProjectStatus,
    validateAccessRequest,
    openNDAModal,
    getPostulations,
    setPostulationProjectId,
    setProjectToEdit,
    getProjectQuestions,
    setPostulationProject,
    getSubProjectBudgets,
})(ProyectoId);

